(function(){
  if (window.__srLanding) return; window.__srLanding = true;

  function init(){
    // Guide fan opens once the hero is on screen
    document.querySelectorAll('[data-sr-fan]').forEach(function(fan){
      setTimeout(function(){ fan.classList.add('is-open'); }, 350);
    });

    // Gentle reveal on scroll (content stays visible without JS / in the theme editor)
    var inEditor = window.Shopify && Shopify.designMode;
    if (!inEditor && 'IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches){
      var els = document.querySelectorAll('.sr-head,.sr-card,.sr-story__copy,.sr-story__photos,.sr-how__grid>*,.sr-shop__grid>*,.sr-comm__item,.sr-faq details,.sr-final__in');
      var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
      els.forEach(function(el){ el.classList.add('sr-rv'); io.observe(el); });
      // Safety net: never leave content hidden (e.g. fast scroll or very short screens)
      setTimeout(function(){ els.forEach(function(el){ el.classList.add('is-in'); }); }, 2500);
    }

    // "Get the guide" buttons scroll to and focus the form
    document.querySelectorAll('[data-sr-jump]').forEach(function(a){
      a.addEventListener('click', function(){
        setTimeout(function(){
          var i = document.querySelector('[data-sr-form] input[type=email]');
          if (i && !i.closest('[hidden]')) i.focus({ preventScroll: true });
        }, 500);
      });
    });

    document.querySelectorAll('[data-sr-form]').forEach(setupForm);
  }

  function showSuccess(form, name){
    var wrap = form.closest('[data-sr-hero]');
    var ok = wrap && wrap.querySelector('[data-sr-success]');
    if (!ok) return;
    if (name){ var n = ok.querySelector('[data-sr-name]'); if (n) n.textContent = name; }
    form.hidden = true; ok.hidden = false; ok.focus();
  }

  function setupForm(form){
    if (form.dataset.srBound) return; form.dataset.srBound = '1';
    var cfg = form.dataset;
    var err = form.querySelector('.sr-form__err');
    var btn = form.querySelector('button[type=submit]');

    form.addEventListener('submit', function(e){
      e.preventDefault();
      var email = form.email.value.trim();
      var name = form.first_name ? form.first_name.value.trim() : '';
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){ err.textContent = cfg.errInvalid; err.hidden = false; form.email.focus(); return; }
      err.hidden = true;
      btn.setAttribute('aria-busy', 'true');

      var props = { smart_restart_hook: cfg.hook, signup_source: cfg.source };
      var attrs = { email: email, properties: props };
      if (name) attrs.first_name = name;

      var body = { data: { type: 'subscription', attributes: {
        custom_source: cfg.sourceLabel,
        profile: { data: { type: 'profile', attributes: attrs } }
      }, relationships: { list: { data: { type: 'list', id: cfg.list } } } } };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
        body: JSON.stringify(body)
      }).then(function(r){
        if (!r.ok) throw new Error('Klaviyo ' + r.status);
        // Tell Klaviyo onsite who this is so the site pop-up doesn't ask again
        try {
          if (window.klaviyo && klaviyo.identify){
            var idt = { email: email, smart_restart_hook: cfg.hook, signup_source: cfg.source };
            if (name) idt.first_name = name;
            klaviyo.identify(idt);
          }
        } catch(_){}
        try { if (window.fbq) fbq('track', 'Lead', { content_name: 'Smart Restart guide' }); } catch(_){}
        showSuccess(form, name);
      }).catch(function(){
        err.textContent = cfg.errNetwork; err.hidden = false;
      }).then(function(){ btn.removeAttribute('aria-busy'); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
